// web/src/copilot/actions/refreshAnalysisAction.tsx
//
// Slice 3 / Task F3: useCopilotAction("refresh_analysis") enqueues a
// fresh L6 analysis run for a material by calling the existing
// POST /api/v1/materials/{id}/refresh endpoint. The response carries a
// `request_id` the agent can poll via the backend check_refresh_status
// tool after a short delay.
//
// Spec §5.4 — UI action wrapper that triggers the same REST endpoint
// the dashboard's Refresh button uses, but reachable from chat on any
// route. The handler returns only `{request_id}` so the agent can chain
// directly into a status poll.
import { useCopilotAction } from "@copilotkit/react-core";

import { api } from "../../api/client";

type RefreshAnalysisArgs = {
  material_id: string;
};

export function useRefreshAnalysisAction(): void {
  useCopilotAction({
    name: "refresh_analysis",
    description:
      "Enqueue a fresh L6 analysis run for a material. Returns request_id. " +
      "After ~30s (or when the user asks for an update), call " +
      "check_refresh_status with that request_id to poll for completion. " +
      'Use when the user asks to "refresh", "rerun", or "redo" an analysis.',
    parameters: [
      { name: "material_id", type: "string", required: true },
    ],
    handler: async ({ material_id }: RefreshAnalysisArgs) => {
      const res = await api.refreshMaterial(material_id);
      return { request_id: res.request_id };
    },
  });
}
